import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from "./locales/en_US.ts";
import ptBR from "./locales/pt_BR.ts";

export const languages = {
	en_US: { nativeName: "English", flag: "US" },
	pt_BR: { nativeName: "Portugues", flag: "BR" },
};

export type LanguageKey = keyof typeof languages;

i18next.use(initReactI18next).init({
	resources: {
		en_US: { translation: enUS },
		pt_BR: { translation: ptBR },
	},
	lng: "en_US",
	fallbackLng: "en_US",
	interpolation: { escapeValue: false },
});

export default i18next;
